import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-621647bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications-list" }

import { onMounted, reactive } from 'vue';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import getNotificationPage from './api-methods';
import studentIcon from '@/assets/icons/emojis/student.png';
import calendarIcon from '@/assets/icons/emojis/calendar.png';
import moment from 'moment';
import { INotificationsForStudentsResponseModel } from './notifications-for-students.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsForStudentsSubpage',
  setup(__props) {

const state = reactive<{ data: INotificationsForStudentsResponseModel }>({
    data: {} as INotificationsForStudentsResponseModel,
});

onMounted(() => {
    const version = localStorage.getItem('notificationsVersion');
    const notifications = localStorage.getItem('notifications');
    notifications && version
        ? getNotificationPage(version, state)
        : getNotificationPage(null, state);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.notifications, (notification) => {
      return (_openBlock(), _createBlock(UniversalCard, {
        props: {
                content: notification.notificationText,
                type: 'outlined',
                dataTags: [
                    {
                        title:
                            'Получатель: ' + notification.notificationReciever,
                        iconCompleteUrl: _unref(studentIcon),
                        color: '',
                    },
                    {
                        title:
                            'Дата отправления: ' +
                            _unref(moment)(notification.date).format('DD.MM.YYYY'),
                        iconCompleteUrl: _unref(calendarIcon),
                        color: '',
                    },
                ],
            },
        key: notification.notificationId
      }, null, 8, ["props"]))
    }), 128))
  ]))
}
}

})